import { formatMoneySafe } from '@/shared/formatSafe';
import { Text } from '@mantine/core';

/** Canonical money display — tabular nums, safe currency formatting. */
export function MoneyAmount({
  amount,
  currency = 'IDR',
  showCurrency = true,
}: {
  amount: number;
  currency?: string;
  /** When false, render digits only (use a separate Currency column). */
  showCurrency?: boolean;
}) {
  return (
    <Text span size="sm" fw={600} style={{ fontVariantNumeric: 'tabular-nums' }} className="money">
      {formatMoneySafe(amount, currency, 'id-ID', { showCurrency })}
    </Text>
  );
}
